import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex space-x-2">
      <button
        className={`px-2 py-1 rounded-md text-sm font-medium transition-colors ${
          i18n.language === 'fr' ? 'bg-black text-white' : 'text-gray-600 hover:text-black'
        }`}
        onClick={() => changeLanguage('fr')}
      >
        FR
      </button>
      <button
        className={`px-2 py-1 rounded-md text-sm font-medium transition-colors ${
          i18n.language === 'en' ? 'bg-black text-white' : 'text-gray-600 hover:text-black'
        }`}
        onClick={() => changeLanguage('en')}
      >
        EN
      </button>
      <button
        className={`px-2 py-1 rounded-md text-sm font-medium transition-colors ${
          i18n.language === 'es' ? 'bg-black text-white' : 'text-gray-600 hover:text-black'
        }`}
        onClick={() => changeLanguage('es')}
      >
        ES
      </button>
    </div>
  );
};

export default LanguageSwitcher;